import React, { useState, useEffect, useContext } from 'react';
import Itinerary from './Itinerary';
import PriceView from '../Views/PriceView';
import Ship from './Ship';
import { Link } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import { CartContext } from '../../Context/CartContext';
import { FaAngleLeft } from 'react-icons/fa';

function CruiseDetail(props) {
  const tabClass = "inline-block hover:bg-cruise_orange hover:rounded px-4 cursor-pointer";
  const viewWrapperClass = "w-10/12 mx-auto relative";

  const [cart, setCart] = useContext(CartContext);
  const [cruiseMaster, setCruiseMaster] = useState({});
  const [doneLoading, setDoneLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [debug, setDebug] = useState("");

  function updateCart(master) {
    const updatedCart = { ...cart };

    updatedCart.masterId = master.id;
    updatedCart.name = master.name;
    setCart(updatedCart);
  }
  function getSelectedDate() {
    if (cart.packageid) {
      let departure = cruiseMaster.cruisePackages.find(p => p.id == cart.packageid).departure;
      if (departure != cart.departure) {
        const updatedCart = { ...cart };
        updatedCart.departure = departure;
        setCart(updatedCart);
      }
      return departure;
    }
    else if (cart.departure) {
      return cart.departure;
    }
    else {
      return cruiseMaster.cheapestDeparture;
    }
  }
  function renderDuration() {
    const from = new Date(cart.departure);
    const to = new Date(cart.departure);
    to.setDate(to.getDate() + cart.duration);
    return <span>
      {new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "long"
      }).format(from)}
      &nbsp;-&nbsp;
      {new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "long"
      }).format(to)}&nbsp;
      ({cart.duration} nights)
    </span>
  }
  function renderSelectedDate() {
    let selectedDate = getSelectedDate();
    if (selectedDate) {
      return <div>
        {
          new Intl.DateTimeFormat("en-GB", {
            day: "2-digit",
            month: "long"
          }).format(new Date(selectedDate))
        }
      </div>
    }
  }
  function renderSelectedCabintype() {
    if (cart.cabins.length === 1) {
      let selectedCabintype = cart.cabins[0].cabintypeName;
      if (selectedCabintype) {
        return <div>
          {selectedCabintype}-cabin
        </div>
      }
    }

  }
  function getSelectedPrice() {
    let cabinPrice = cart.cabins.reduce((a, b) => +a + +b.price, 0);
    if (cabinPrice) {
      return parseInt(cabinPrice);
    }
    else {
      return cruiseMaster.lowestPrice / 100;
    }
  }
  function renderSelectedPrice() {
    let price = getSelectedPrice();

    return <React.Fragment>
      <span className="text-base">
        <NumberFormat value={price} displayType={'text'} decimalSeparator={','} thousandSeparator={'.'} prefix={'DKK '} />
      </span>
    </React.Fragment>
  }
  function getDefaultTabIndex() {
    return 0;
  }

  useEffect(() => {
    setDoneLoading(false);
    let path = `/api/proxy/Details?tokenstring=${encodeURIComponent(props.match.params.token)}`;
    path += `&id=${encodeURIComponent(props.match.params.masterid)}`;

    fetch(path)
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then((result) => {
        setCruiseMaster(result.content);
        updateCart(result.content);
        //setDebug(JSON.stringify(result));
        setDoneLoading(true);
      })
      .catch(err => {
        setHasError(true);
        setDoneLoading(true);
      });
  }, []);

  if (!doneLoading) return <div>Loading...</div>;
  if (hasError)
    return <div>Failed to fetch open jobs 😟</div>;

  return (
    <div>
      <div >
        <Tabs defaultIndex={getDefaultTabIndex()}
          selectedTabClassName="react-tabs__tab--selected bg-cruise_darkblue text-white border-solid border-b-4 border-cruise_orange"
          selectedTabPanelClassName="react-tabs__tab-panel--selected p-2"
        >
          <div
            style={{ boxShadow: '0px 10px 10px rgba(0,0,0,0.16)' }}
            className="flex justify-between bg-cruise_darkblue sticky top-0 z-10 text-white py-1">
            <div className="flex flex-1 justify-between items-center">
              <div className="flex px-4 py-2 ">
                <Link
                  to={"/search/" + props.match.params.token + "/" + cruiseMaster.id}
                  className="text-white px-2 py-1 hover:no-underline hover:bg-primary-button-hover hover:text-black">
                  <span className="flex items-center"><FaAngleLeft size={18} /> Back</span>
                </Link>
              </div>
              <div className="flex flex-col justify-center">
                <span className="font-semibold">{cruiseMaster.name}</span>
                {renderDuration()}
              </div>
              <div className="">
                <TabList className="text-white p-2 ">
                  <Tab className={tabClass}>Route</Tab>
                  <Tab className={tabClass}>Ship</Tab>
                  <Tab className={tabClass}>Prices</Tab>
                </TabList>
              </div>
              <div className="flex justify-end items-center text-right">
                <div className="flex flex-col px-4 py-3 text-white">
                  {renderSelectedPrice()}
                total
              </div>
                <div className="flex p-2 ">
                  <Link to={"/booking/" + props.match.params.token + "/" + cart.masterId}
                    className="px-10 py-2 bg-primary-button text-black font-semibold hover:no-underline hover:bg-primary-button-hover hover:text-black">
                    Book now
              </Link>
                </div>
              </div>
            </div>
          </div>
          <TabPanel>
            <Itinerary
              pictureserver={cruiseMaster.pictureserver}
              itineraries={cruiseMaster.itineraries}
              cruisepackages={cruiseMaster.cruisePackages} />
          </TabPanel>
          <TabPanel>
            <Ship pictureserver={cruiseMaster.pictureserver} ship={cruiseMaster.ship} />
          </TabPanel>
          <TabPanel>
            <PriceView
              wrapperClass={viewWrapperClass}
              selectedCruise={cruiseMaster}
              selectedDate={getSelectedDate()}
              pictureserver={cruiseMaster.pictureserver}
              cabinprimarytypes={cruiseMaster.cabinprimarytypes}
              showNavigation={false}
              horizontal={false}
            />
          </TabPanel>
        </Tabs>
      </div>

      <div>{debug}</div>

    </div>
  );
}

export default CruiseDetail;